// removed by extract-text-webpack-plugin
module.exports = {"link":"checkbox__link___fZgNB","linkList":"checkbox__linkList___3tQBX","time":"checkbox__time___1FsA5","detail":"checkbox__detail___1rptb","field":"checkbox__field___3aJok","check":"checkbox__check___3KDPA","text":"checkbox__text___2Qd13"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/checkbox.scss
// module id = 666
// module chunks = 0